'use strict';
var _ = require('underscore');
var request = require('superagent');
var assetsHelper = require('./assetsHelper');

var defaulgConfig = window.isDev ?
  {
    iOSGuide: true,
    logo: assetsHelper.getAsset('logo.png'),
    showControlPanel: true, // 显示控制面板
    shell: '', // 外壳
    background: '#F0F0F0', // 背景色
    alwaysShowLinks: true, // 始终显示链接
    hoverShowLinks: false, // 鼠标滑过时显示链接
    hoverShowRemarks: true, //鼠标滑过时，显示备注
    showComments: true, // 显示批注
    showQRCode: true, // 显示二维码
    hintLinks: false, // 闪烁提示链接
    scrollRemarks: true // 链接自动滚动
  } : {
    iOSGuide: true,
    logo: assetsHelper.getAsset('logo.png'),
    showControlPanel: true, // 显示控制面板
    shell: '', // 外壳
    background: '#F0F0F0', // 背景色
    alwaysShowLinks: false, // 始终显示链接
    hoverShowLinks: false, // 鼠标滑过时显示链接
    hoverShowRemarks: true, //鼠标滑过时，显示备注
    showComments: true, // 显示批注
    showQRCode: true, // 显示二维码
    hintLinks: false, // 闪烁提示链接
    scrollRemarks: true // 链接自动滚动
  };

var config = _.extend(defaulgConfig, window.config);

exports.getConfig = function (cb) {
  if (window.mockplus) {
    return request.get('config.json?rnd=' + Math.random()).end(function (err, res) {
      var newConfig;
      if (err) {
        return cb(null, config);
      }
      try {
        newConfig = _.extend(config, res.body);
        if (!newConfig.logo) {
          newConfig.logo = assetsHelper.getAsset('logo.png');
        }
        cb(null, newConfig);
      } catch (e) {
        cb(null, config);
      }
    });
  }
  cb(null, config);
};

exports.notForceUseCurrentBrowser = function () {
  return window.location.href.indexOf('force=1') === -1;
};



// WEBPACK FOOTER //
// ./src/helper/configHelper.js